export default __webpack_public_path__ + "b9021bb757262a32de6d8931015051d9.svg";